<div class="layout-content">
  <sub-header>
    <ces-breadcrumb
      [menuItems]="breadcrumbs"
      variation="design"
    ></ces-breadcrumb>
  </sub-header>

  <ces-card
    style="height: calc(100vh - 160px); overflow-y: auto"
    class="card-job-list"
  >
    <ces-card-header>
      <div class="header-grid-container">
        <div class="textbx activity-text-block">
          <span class="activity-title">Activity</span>
          <span
            *ngIf="activityText"
            class="activity-text"
            >{{ activityText }}</span
          >
        </div>
      </div>
    </ces-card-header>
    <ces-card-body>
      <div class="activity-container">
        <div class="stats-container mb-3">
          <div class="row">
            <div class="col-md-4 col-6 col-sm-6 col-lg-3 col-xl-2">
              <div class="stats-block">
                <div class="stat-title">Total Users</div>
                <div class="stat-value">
                  <h4>{{ totalUsers }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6 col-sm-6 col-lg-3 col-xl-2">
              <div class="stats-block">
                <div class="stat-title">Total Active Uses</div>
                <div class="stat-value">
                  <h4>{{ totalActiveUsers }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6 col-sm-6 col-lg-3 col-xl-2">
              <div class="stats-block">
                <div class="stat-title">Applications</div>
                <div class="stat-value">
                  <h4>{{ stats?.clients ? stats?.clients : 0 }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6 col-sm-6 col-lg-3 col-xl-2">
              <div class="stats-block">
                <div class="stat-title">APIs</div>
                <div class="stat-value">
                  <h4>{{ stats?.resource_servers ? stats?.resource_servers : 0 }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6 col-sm-6 col-lg-3 col-xl-2">
              <div class="stats-block">
                <div class="stat-title">Connections</div>
                <div class="stat-value">
                  <h4>{{ stats?.connections ? stats?.connections : 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="chart-widget-loader"
            *ngIf="statLoader"
          >
            <ces-loaders
              type="spinner"
              size="medium"
              textPosition="center"
            ></ces-loaders>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="chart-block">
              <div class="chart-title-block">
                <span class="chart-title">Daily Active Users</span>
                <span
                  tooltip="Unique users with successful authentication or authorization activity."
                  ><i class="icon icon-info activity-info-icon"></i
                ></span>
              </div>
              <div class="chart-value">
                <h4>{{ dailyActiveUserCount }}</h4>
              </div>
              <div class="chart">
                <div
                  id="dailyActiveUserChart"
                  class="w-100"
                  #dailyActiveUserChart
                ></div>
              </div>
              <div
                class="chart-widget-loader"
                *ngIf="loader"
              >
                <ces-loaders
                  type="spinner"
                  size="medium"
                  textPosition="center"
                ></ces-loaders>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12 col-xl-6 user-retention-block">
            <div class="chart-block">
              <div class="col-12">
                <div class="chart-title-block">
                  <span class="chart-title">User Retention</span>
                  <span tooltip="Active users divided by all the users during given time period"
                    ><i class="icon icon-info activity-info-icon"></i
                  ></span>
                </div>
                <div class="chart-value">
                  <h4>{{ retentionCount }}%</h4>
                </div>
                <div class="chart">
                  <div
                    id="retentionChart"
                    class="w-100"
                    #retentionChart
                  ></div>
                </div>
              </div>
              <div
                class="chart-widget-loader"
                *ngIf="loader"
              >
                <ces-loaders
                  type="spinner"
                  size="medium"
                  textPosition="center"
                ></ces-loaders>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-xl-6">
            <div class="chart-block">
              <div class="col-12">
                <div class="chart-title-block">
                  <span class="chart-title">Signups</span>
                  <span tooltip="The count of total successful signuips"
                    ><i class="icon icon-info activity-info-icon"></i
                  ></span>
                </div>
                <div class="chart-value">
                  <h4>{{ signupCount }}</h4>
                </div>
                <div class="chart">
                  <div
                    id="signupChart"
                    class="w-100"
                    #signupChart
                  ></div>
                </div>
              </div>
              <div
                class="chart-widget-loader"
                *ngIf="loader"
              >
                <ces-loaders
                  type="spinner"
                  size="medium"
                  textPosition="center"
                ></ces-loaders>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="chart-block">
              <div class="chart-title-block">
                <span class="chart-title">Failed Logins</span>
                <span tooltip="The count of total failed login events"
                  ><i class="icon icon-info activity-info-icon"></i
                ></span>
              </div>
              <div class="chart-value">
                <h4>{{ failedLoginCount }}</h4>
              </div>
              <div class="chart">
                <div
                  id="failedLoginChart"
                  class="w-100"
                  #failedLoginChart
                ></div>
              </div>
              <div
                class="chart-widget-loader"
                *ngIf="loader"
              >
                <ces-loaders
                  type="spinner"
                  size="medium"
                  textPosition="center"
                ></ces-loaders>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ces-card-body>
  </ces-card>
</div>
